const fakeTopCustomers = [
  {
    _id: "77aacf1a49897b8639560001",
    fullName: "Valeria Ortega",
    phone: "78945612",
    rating: 4.8,
    totalServices: 45,
  },
  {
    _id: "77baf6ab341d99e1e0e0002",
    fullName: "Marco Ríos",
    phone: "76543210",
    rating: 4.2,
    totalServices: 38,
  },
  {
    _id: "7782fdac54cefdc68eca0003",
    fullName: "Gabriela Menacho",
    phone: "74561238",
    rating: 5,
    totalServices: 27,
  },
  {
    _id: "775dddb74de53c27d4890004",
    fullName: "Carlos Méndez",
    phone: "70981234",
    rating: 3.9,
    totalServices: 19,
  },
  {
    _id: "77ccaeeec9e5b92429430005",
    fullName: "Rocío Vargas",
    phone: "79845613",
    rating: 0,
    totalServices: 6,
  },
  {
    _id: "779cee46d43e34c5200b0006",
    fullName: "Cliente Ficticio",
    phone: "00000000",
    rating: 5,
    totalServices: 3,
  },
];

export default fakeTopCustomers;
